import React from 'react'
import {Divider as AntDivider, Drawer, Layout} from 'antd'
import classNames from 'classnames'
import {observer} from 'mobx-react'

import {ROUTES} from '@/router/routes'
import {Logo} from '@/components'
import {Burger, SiderMenu} from '../'
import {getPermissions, navigateUserAfterLogin} from '@/stores/auth/services'
import {MerchantSelect} from '@/layouts/MainLayout/components'
import {SiderLogoContainer} from '@/layouts/MainLayout/components/SiderLogoContainer'
import {MENU} from '@/constants/playwright-ids'
import {Theme} from '@/constants'

import {SiderProps} from './props'
import styles from './styles.scss'

const siderExpandedWidth = 304
const siderCollapsedWidth = 64

const Divider = () => <AntDivider className={styles.divider} />

export const Sider: React.FC<SiderProps> = observer((props) => {
    const {
        isMobile,
        isCollapsed,
        setCollapsed,
        menuItems,
        openKeys,
        selectedKeys,
        onOpenChange,
        className
    } = props

    const renderHeader = () => (
        <div className={styles.header}>
            <Burger onClick={() => setCollapsed(!isCollapsed)} />
            {!isCollapsed && (
                <SiderLogoContainer>
                    <Logo
                        onClick={() => navigateUserAfterLogin(getPermissions())}
                        href={ROUTES.home}
                        type={Theme.LIGHT}
                        isBlank={false}
                    />
                </SiderLogoContainer>
            )}
        </div>
    )

    const renderContent = () => (
        <div className={classNames(styles.content, {[styles.mobile]: isMobile})}>
            {renderHeader()}
            <MerchantSelect isCollapsed={isCollapsed} />
            <Divider />
            <SiderMenu
                menuItems={menuItems}
                selectedKeys={selectedKeys}
                openKeys={isCollapsed ? undefined : openKeys}
                onSelect={() => {
                    if (isMobile) {
                        setCollapsed(true)
                    }
                }}
                onOpenChange={onOpenChange}
            />
        </div>
    )

    return isMobile ? (
        <Drawer
            open={!isCollapsed}
            placement='left'
            className={classNames(styles.drawer, className)}
            closable={false}
            width={siderExpandedWidth}
            onClose={() => setCollapsed(false)}
        >
            {renderContent()}
        </Drawer>
    ) : (
        <Layout.Sider
            className={classNames(styles.sider, className)}
            collapsible
            collapsed={isCollapsed}
            trigger={null}
            width={siderExpandedWidth}
            collapsedWidth={siderCollapsedWidth}
            data-test-id={MENU}
        >
            {renderContent()}
        </Layout.Sider>
    )
})
